import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/dots_gray.svg'
import _imports_1 from '../../assets/reject.svg'
import _imports_2 from '../../assets/edit.svg'
import _imports_3 from '@/assets/delete.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "dots",
  class: "w-3 h-3"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "absolute lg:right-0 md:right-0 left-0 top-auto mt-2 w-52 rounded-xl shadow-xl text-sm overflow-hidden z-20"
}
const _hoisted_4 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_5 = { class: "flex flex-col mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Reject")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Edit")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-200 mx-4 my-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-8 w-8 text-gray-500",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "8",
      y: "8",
      width: "12",
      height: "12",
      rx: "2"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4 text-xs" }, "Copy candidate")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4 text-xs" }, "Remove candidate")
], -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen)),
      type: "button",
      class: "select-none p-2 hover:bg-gray-100 rounded-full"
    }, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rejectCandidate && _ctx.rejectCandidate(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_7),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openEdit && _ctx.openEdit(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_9),
                  _hoisted_10,
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyCandidate && _ctx.copyCandidate(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_12),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteCandidate && _ctx.deleteCandidate(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_14)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512)), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}